import { Injectable } from "@angular/core";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class CustomDateRangeAdapter {
selectedDateRange: { start: moment.Moment; end: moment.Moment } | null = null;
  constructor() {}

  getLocaleConfig(): any {
    let daysOfWeek: string[];
    let monthsArr: string[];
    let applyLabel: string;
    let clearLabel: string;

    if (localStorage.getItem("lan") === "th") {
      daysOfWeek = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];
      monthsArr = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      applyLabel = "ตกลง";
      clearLabel = "ล้างข้อมูล";
    } else {
      daysOfWeek = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
      monthsArr = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      applyLabel = "Apply";
      clearLabel = "Clear";
    }

    return {
      format: "DD/MM/YYYY",
      applyLabel: applyLabel,
      clearLabel: clearLabel,
      monthNames: monthsArr,
      daysOfWeek: daysOfWeek,
      firstDay: 0, // Adjust if necessary
    };
  }

  toBuddhistEra(date: moment.Moment): moment.Moment {
    if (localStorage.getItem("lan") === "th") {
      console.log("Before Conversion:", date.format("YYYY-MM-DD"));
  
      const currentYear = date.year();
      if (currentYear >= 2500) {
        console.log("Already in BE, skipping conversion:", date.format("YYYY-MM-DD"));
        return date.clone(); // No need to add 543 again
      }
  
      const convertedDate = date.clone().year(currentYear + 543);
      console.log("After Corrected Conversion:", convertedDate.format("YYYY-MM-DD"));
      return convertedDate;
    }
    return date.clone();
  }
  getRanges(): any {
    const todayBE = this.toBuddhistEra(moment());
    if (localStorage.getItem("lan") === "th") {
      return {
        วันนี้: [todayBE, todayBE],
        เมื่อวาน: [
          this.toBuddhistEra(moment().subtract(1, "days")),
          this.toBuddhistEra(moment().subtract(1, "days")),
        ],
        "7 วันที่ผ่านมา": [
          this.toBuddhistEra(moment().subtract(6, "days")),
          this.toBuddhistEra(moment()),
        ],
        "30 วันที่ผ่านมา": [
          this.toBuddhistEra(moment().subtract(29, "days")),
          this.toBuddhistEra(moment()),
        ],
        เดือนนี้: [
          this.toBuddhistEra(moment().startOf("month")),
          this.toBuddhistEra(moment().endOf("month")),
        ],
        เดือนที่แล้ว: [
          this.toBuddhistEra(moment().subtract(1, "month").startOf("month")),
          this.toBuddhistEra(moment().subtract(1, "month").endOf("month")),
        ],
      };
    } else {
      return {
        //     this.ranges = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment().subtract(1, "month").startOf("month"),
          moment().subtract(1, "month").endOf("month"),
        ],
      };
    }
  }
  setSelectedDateRange(start: moment.Moment, end: moment.Moment): void {
    if (localStorage.getItem('lan') === 'th') {
      this.selectedDateRange = {
        start: this.toBuddhistEra(start.clone()),
        end: this.toBuddhistEra(end.clone()),
      };
    } else {
      this.selectedDateRange = { start, end };
    }
  }
  getSelectedDateRange(): { start: moment.Moment; end: moment.Moment } | null {
    if (this.selectedDateRange) {
        return {
          start: this.toBuddhistEra(this.selectedDateRange.start.clone()),
          end: this.toBuddhistEra(this.selectedDateRange.end.clone()),
        };
      }
      return null;
  }

}
